import { apiClient } from './apiClient';
import { getApiData, getProp } from '../utils/apiResponse';

export interface GitHubLicenseSummary {
  organization: string;
  licensedUsers: number;
  totalSeats?: number;
  availableSeats?: number;
  retrievedAtUtc: string;
}

export interface GitHubLicenseUser {
  login: string;
  name?: string;
  email?: string;
  company?: string;
  location?: string;
  avatarUrl?: string;
  profileUrl?: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export const githubLicenseService = {
  async getSummary(): Promise<GitHubLicenseSummary> {
    const response = await apiClient.get<ApiResponse<GitHubLicenseSummary>>('/github/licenses');
    return getApiData<GitHubLicenseSummary>(response, 'loading GitHub license summary');
  },

  async getUsers(): Promise<GitHubLicenseUser[]> {
    const response =
      await apiClient.get<ApiResponse<GitHubLicenseUser[]>>('/github/licenses/users');
    const data = getApiData<any>(response, 'loading GitHub licensed users');

    if (Array.isArray(data)) {
      return data as GitHubLicenseUser[];
    }

    const value = getProp(data, 'value');
    if (Array.isArray(value)) {
      return value as GitHubLicenseUser[];
    }

    return [];
  },
};
